import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';
import {News} from '../resources/News';

/**
 * This event can be fired to indicate that some data as requested via the {@see NewsExportRequested} event is
 * available and can be processed.
 */
export class NewsExportAvailable extends EntityExportAvailableEvent<News> {
}
